import * as React from 'react';

export interface ITitleProps {
  text: string;
  className?: string;
}

export function Title({ text, className }: ITitleProps) {
  return (
    <h1 className={`p-2 text-3xl font-semibold text-center ${className}`}>
      {text}
    </h1>
  );
}
